<template>
    <div>
      <div class="air__utils__scrollTable mb-4">
        <a-table :rowKey="record => record.id" :columns="columns" :dataSource="data" :pagination="false"
          :scroll="{ x: '100%' }" :rowSelection="computedSelect" :loading="loading">
          <!-- <template slot="driver" slot-scope="driver">
            <div class="text-wrap">
              <div class="font-weight-bold text-wrap">{{ driver.first_name + ' ' + driver.last_name }}</div>
            </div>
          </template> -->
          <!-- <template slot="name" slot-scope="name">
            <div class="text-wrap">
              <div class="font-weight-bold text-wrap">{{ name }}</div>
              <div class="text-gray-4">{{user.position}}</div>
            </div>
          </template> -->
          <!--        <template slot="description" slot-scope="description">
              <div>{{description}}</div>
            </template>-->
          <!-- <template slot="category" slot-scope="category">
            <div>{{ category.name }}</div>
          </template> -->
          <!-- <template slot="school_class" slot-scope="school_class">
            <div>{{ school_class ? school_class.name : null }}</div>
          </template> -->
          <template slot="action" slot-scope="record">
            <div class="text-nowrap">
              <!-- <a-tooltip
                  placement="top"
                  title="Create inward transaction"
                >
                <a href="javascript:"  class="btn btn-sm btn-success mr-2" @click="showInwardTransactionModal(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fa-lg fe  fe-plus-square" />
                  </span>
                </a>
                </a-tooltip>
                <a-tooltip
                  placement="top"
                  title="Create outward transaction"
                >
                <a href="javascript:" class="btn btn-sm btn-warning mr-2" @click="showOutwardTransactionModal(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fa-lg fe fe-minus-square" />
                  </span>
                </a>
                </a-tooltip> -->
              <a-tooltip placement="top" title="Edit book">
                <a href="javascript:" class="btn btn-sm btn-light btn-with-addon mr-2" @click="showEditModal(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-edit" />
                  </span>
                  Edit
                </a>
              </a-tooltip>
             <a-tooltip placement="top" title="Delete book">
                <a href="javascript:" class="btn btn-sm btn-danger btn-with-addon" @click="handleDelete(record)">
                  <span class="btn-addon">
                    <i class="btn-addon-icon fe fe-trash" />
                  </span>
                  Delete
                </a>
              </a-tooltip>
            </div>
          </template>
        </a-table>
      </div>
      <!-- <edit-school-class ref="editClass" @edited="handleEdited" /> -->
      <edit-route @onEdited="handleAfteredit"></edit-route>
    </div>
</template>

<script>
import EditRoute from '@/components/transport/route/edit'

const columns = [
  { title: 'Route No.', width: 100, dataIndex: 'route_no', scopedSlots: { customRender: 'route_no' } },
  { title: 'Route Name', width: 250, dataIndex: 'route_name', scopedSlots: { customRender: 'route_name' } },
  { title: 'Location', width: 150, dataIndex: 'location', scopedSlots: { customRender: 'location' } },
  // { title: 'Vehicle Type', width: 100, dataIndex: 'vehicle_type', scopedSlots: { customRender: 'vehicle_type' } },
  // { title: 'Route', width: 150, dataIndex: 'routes[0].route_name', scopedSlots: { customRender: 'routes[0].route_name' } },
  // { title: 'Location', width: 150, dataIndex: 'routes[0].location', scopedSlots: { customRender: 'routes[0].location' } },
  { title: 'Actions', className: 'text-right', scopedSlots: { customRender: 'action' } },
]
// const fakedata = [
//   { id: 1, name: 'Eletronics', description: 'Category for electronics items' },
//   { id: 2, name: 'Fashion', description: 'Category for Fashion items' },
//   { id: 3, name: 'Furniture', description: 'Category for Furniture items' }
// ]
// const exposedEvents = { OnSubmit: 'onsubmit', OnEdit: 'onedit', OnDelete: 'ondelete' }

export default {
  name: 'RouteTable',
  components: {
    EditRoute,
  },
  props: {
    select: Boolean,
    loading: Boolean,
    rolesetting: { type: Object },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      columns,
      showeditform: false,
      datatoedit: {},
      // data: [],
    }
  },
  computed: {
    computedSelect: function () {
      if (!this.select) {
        return null
      }
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      }
    },
  },
  methods: {
    handleAfteredit() {
      this.$emit('updateTable')
    },
    showEditModal(record) {
      this.$eventBus.$emit('openEditForm', record)
    },
    closeEditform() {
      this.showeditform = false
    },
    handleDelete(record) {
      this.$confirm({
        title: 'Are you sure to delete this vehicle?',
        content: `Clicking yes will delete this vehicle "${record.route_no}"`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .delete('/api/transport/route/' + record.id)
            .then((resp) => {
              // this.$emit('updateTable')
              // console.log('resp: ', resp)
              // Custom resp status: resp.data.status (not resp.status)
              if (resp.data.status === 200) {
                this.$emit('updateTable') // Reload the table
                this.$nprogress.done()
                this.$notification['success']({
                  message: 'Deleted Successfully!',
                  description: resp.data.message,
                })
              } else {
                this.$nprogress.done()
                this.$notification['warning']({
                  message: 'Route cannot be deleted!',
                  description: resp.data.message,
                })
              }
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
  },
}
</script>
